import Particle01 from './Particle01/Particle01';
import Particle01_EN from './Particle01/Particle01_EN';
import Particle02 from './Particle02/Particle02';
import Particle02_EN from './Particle02/Particle02_EN';
import Particle03 from './Particle03/Particle03';
import Particle03_EN from './Particle03/Particle03_EN';
import Particle05 from './Particle05/Particle05';
import Particle05_EN from './Particle05/Particle05_EN';
import Particle07 from './Particle07/Particle07';
import Particle07_EN from './Particle07/Particle07_EN';
import Particle09 from './Particle09/Particle09';
import Particle09_EN from './Particle09/Particle09_EN';
import Particle11 from './Particle11/Particle11';
import Particle11_EN from './Particle11/Particle11_EN';
import Particle12 from './Particle12/Particle12';
import Particle12_EN from './Particle12/Particle12_EN';
import Particle14 from './Particle14/Particle14';
import Particle14_EN from './Particle14/Particle14_EN';
import Particle15 from './Particle15/Particle15';
import Particle15_EN from './Particle15/Particle15_EN';
import Particle17 from './Particle17/Particle17';
import Particle17_EN from './Particle17/Particle17_EN';
import Particle19 from './Particle19/Particle19';
import Particle19_EN from './Particle19/Particle19_EN';
import Particle21 from './Particle21/Particle21';
// import Particle21_EN from './Particle21/Particle21_EN';
import Particle22 from './Particle22/Particle22';
// import Particle22_EN from './Particle22/Particle22_EN';
import Particle23 from './Particle23/Particle23';
import Particle23_EN from './Particle23/Particle23_EN';
import Particle24 from './Particle24/Particle24';
// import Particle24_EN from './Particle24/Particle24_EN';
import Particle25 from './Particle25/Particle25';
// import Particle25_EN from './Particle25/Particle25_EN';
import Particle26 from './Particle26/Particle26';
// import Particle26_EN from './Particle26/Particle26_EN';
import Particle27 from './Particle27/Particle27';
// import Particle27_EN from './Particle27/Particle27_EN';

const Particles = {
  1: {
    de: {particle: Particle01},
    en: {particle: Particle01_EN}
  },
  2:  {
    de:{particle: Particle02, duration: '2:30m', type: 'Bilder', defaultTeaser: 'Die sechs Disziplinen'},
    en:{particle: Particle02_EN, duration: '2:30m', type: 'Slideshow', defaultTeaser: 'The six Cybathlon disciplines'}
  },
  3:  {
    de: {particle: Particle03, duration: '2:00m', type: 'Text, Film', defaultTeaser: 'Aus der Reha an den Cybathlon'},
    en: {particle: Particle03_EN, duration: '2:00m', type: 'Text, video', defaultTeaser: 'From rehab to Cybathlon'}
  },
  5: {
    de: {particle: Particle05, duration: '1:00m', type: 'Text', defaultTeaser: 'Der Rollstuhl-Entwickler'},
    en: {particle: Particle05_EN, duration: '1:00m', type: 'Text', defaultTeaser: 'The wheelchair developer'}
  },
  7: {
    de: {particle: Particle07, duration: '0:45m', type: 'Film', defaultTeaser: 'So erklimmt der Rollstuhl eine Treppe'},
    en: {particle: Particle07_EN, duration: '0:45m', type: 'Video', defaultTeaser: 'Wheelchair climbing up steps'}
  },
  9: {
    de: {particle: Particle09, duration: '2:30m', type: 'Bildstrecke', defaultTeaser: 'Die Rollstühle im Rennen'},
    en: {particle: Particle09_EN, duration: '2:30m', type: 'Slideshow', defaultTeaser: 'The wheelchairs in the race'}
  },
  11: {
    de: {particle: Particle11, duration: '1:00m', type: 'Text', defaultTeaser: 'Die Idee hinter dem Wettkampf'},
    en: {particle: Particle11_EN, duration: '1:00m', type: 'Text', defaultTeaser: 'The idea behind the Cybathlon'}
  },
  12: {
    de: {particle: Particle12, duration: '1:00m', type: 'Bildstrecke', defaultTeaser: 'Die Aufgaben mit Armprothese'},
    en: {particle: Particle12_EN, duration: '1:00m', type: 'Slideshow', defaultTeaser: 'Tasks arm prosthesis course'}
  },
  14: {
    de: {particle: Particle14, duration: '0:30m', type: 'Film', defaultTeaser: 'Wie funktioniert ein Exoskelett?'},
    en: {particle: Particle14_EN, duration: '0:30m', type: 'Video', defaultTeaser: 'How does an exoskeleton work?'}
  },
  15: {
    de: {particle: Particle15, duration: '0:30m', type: 'Bildstrecke', defaultTeaser: 'Hindernisse im Exoskelett-Parcours'},
    en: {particle: Particle15_EN, duration: '0:30m', type: 'Slideshow', defaultTeaser: 'Obstacles in the exoskeleton race'}
  },
  17: {
    de: {particle: Particle17, duration: '1:45m', type: 'Text', defaultTeaser: 'Diese Roboteranzüge gibt es bereits'},
    en: {particle: Particle17_EN, duration: '1:45m', type: 'Text', defaultTeaser: 'These robotic suits are already available'}
  },
  19: {
    de: {particle: Particle19, duration: '0:30m', type: 'Bildstrecke', defaultTeaser: 'Die Gehirn-Computer-Schnittstelle'},
    en: {particle: Particle19_EN, duration: '0:30m', type: 'Slideshow', defaultTeaser: 'The brain-computer interface'}
  },
  21: {
    de: {particle: Particle21, duration: '1:30m', type: 'Film', defaultTeaser: 'Selbsttest: Wie geht Gedankensteuerung?'},
    en: {particle: Particle21, duration: '1:30m', type: 'Video', defaultTeaser: 'Self test: How does brain control work?'}
  },
  22: {
    de: {particle: Particle22, duration: '0:30m', type: 'Film', defaultTeaser: 'Was am Wettkampf schiefging'},
    en: {particle: Particle22, duration: '0:30m', type: 'Video', defaultTeaser: 'These things went wrong'}
  },
  23: {
    de: {particle: Particle23, duration: '1:00m', type: 'Bildstrecke', defaultTeaser: 'Das waren die Sieger'},
    en: {particle: Particle23_EN, duration: '1:00m', type: 'Slideshow', defaultTeaser: 'The winners'}
  },
  24: {
    de: {particle: Particle24, duration: '0:20m', type: 'Film', defaultTeaser: 'Fahrradfahren trotz Lähmung'},
    en: {particle: Particle24, duration: '0:20m', type: 'Video', defaultTeaser: 'Riding a bike with paralyzed legs'}
  },
  25: {
    de: {particle: Particle25, duration: '0:30m', type: 'Film', defaultTeaser: 'Wie fühlt sich Muskelstimulation an?'},
    en: {particle: Particle25, duration: '0:30m', type: 'Video', defaultTeaser: 'How does electric muscle stimulation feel like?'}
  },
  26: {
    de: {particle: Particle26, duration: '1:15m', type: 'Film', defaultTeaser: 'Greifen mit einer Armprothese'},
    en: {particle: Particle26, duration: '1:15m', type: 'Video', defaultTeaser: 'Living with an arm prosthesis'}
  },
  27: {
    de: {particle: Particle27, duration: '0:30m', type: 'Film', defaultTeaser: 'So knapp siegte das Schweizer Team'},
    en: {particle: Particle27, duration: '0:30m', type: 'Video', defaultTeaser: 'Narrow victory of the Swiss team'}
  }
}

export default Particles;



/** WEBPACK FOOTER **
 ** ./src/Particles/ListExport.js
 **/